import { useState } from "react";
import { useTranslation } from "react-i18next";
import { homeFaqs } from "@/mocks/homeFaqs";
import { useCurrentLanguage, localize } from "@/hooks/useLanguage";

export default function FaqSection() {
  const { t } = useTranslation();
  const lang = useCurrentLanguage();
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            {t("faq.title")}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">{t("faq.subtitle")}</p>
        </div>

        <div className="space-y-3">
          {homeFaqs.map((faq, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={idx}
                className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpen(isOpen ? null : idx)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900">
                    {localize(faq.question, lang)}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center shrink-0">
                    <i className={`ri-add-line text-foreground-500 transition-transform ${isOpen ? "rotate-45" : ""}`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {localize(faq.answer, lang)}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}